import { create } from 'apisauce'

const baseURL = 'https://api.mapbox.com'

const apiMaps = create({
  baseURL,
  headers: {},
})

apiMaps.axiosInstance.interceptors.response.use(
  (response) => {
    // console.log('response maps', response)
    return response
  }, error => (
    new Promise((resolve, reject) => {
      // console.log('response error', error.response)
      if (error.response.status === 401) {
        // callToLogin()
      } else {
        reject()
      }
    })
  ))

apiMaps.addRequestTransform((request) => {
  // console.log('REQUEST MAPS')
  // console.log(request)
})

export default apiMaps
